// extracted by mini-css-extract-plugin
export default {"priceCenterContainer":"styles_priceCenterContainer__YBGz-","navContainer":"styles_navContainer__m5-JY"};